import './TabNavigation.css';

export default function TabNavigation({ activeTab, onTabChange }) {
  const tabs = [
    { id: 'phone', icon: '📞', label: 'Phone Controls' },
    { id: 'outreach-search', icon: '🔍', label: 'Outreach Search' },
    { id: 'errors', icon: '⚠️', label: 'Errors' },
    { id: 'call-experience', icon: '🗣️', label: 'Call Experience' },
  ];

  return (
    <nav className="tab-navigation">
      <div className="nav-header">
        <h2>Phoenix</h2>
      </div>
      <div className="nav-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
            title={tab.label}
            aria-current={activeTab === tab.id ? 'page' : undefined}
          >
            <span className="tab-icon" aria-hidden="true">{tab.icon}</span>{' '}
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
